import { useNavigate } from "react-router-dom";
import "../../styles/common/logo.css";

const Logo = ({ white = false }) => {
  const navigate = useNavigate();
  return (
    <div className="logo" onClick={() => navigate("/")}>
      <p className={white ? "white-logo" : "left-logo"}>Visual</p>
      <p className={white ? "white-logo" : "right-logo"}>Lab</p>
    </div>
  );
};

export default Logo;
